// src/pages/TechnicalSalesWorkflow.jsx
import React from 'react';
import ZoomableImage from '../components/ZoomableImage';
import './Workflows.css';

export default function TechnicalSalesWorkflow() {
  const svgPath = '/svgs/technical-sales-workflow.svg';

  return (
    <div className="workflow-page">
      <h1>Technical Sales Workflow</h1>
      <p>
        This flowchart outlines the processes for our technical sales operations, including customer engagement, quotation, follow-up, and closure.
      </p>

      <div className="svg-container">
        <ZoomableImage src={svgPath} alt="Technical Sales Workflow" />
      </div>

      <div className="download-container">
        <a
          href={svgPath}
          download="technical-sales-workflow.svg"
          className="download-button"
        >
          Download SVG
        </a>
      </div>
    </div>
  );
}
